import { createFileRoute, Link } from "@tanstack/react-router"
import { ArrowLeft, Plus } from "lucide-react"
import { PageHeader } from "@/components/layout"
import { BACK_LINK_CLASS } from "@/components/promotions/back-link"
import { Button } from "@/components/ui/button"
import { CouponProgramsGrid } from "@/features/coupons-admin/CouponProgramsGrid"
import { useCouponPrograms } from "@/queries/marketplace"

export const Route = createFileRoute("/coupons/programs/")({
	component: CouponProgramsPage,
})

function CouponProgramsPage() {
	const { programs, isLoading, error } = useCouponPrograms()

	return (
		<div className="flex h-[calc(100vh-3rem)] flex-col gap-6 p-6">
			<div className="flex flex-col gap-2">
				<Link to="/coupons" search={{} as never} className={BACK_LINK_CLASS}>
					<ArrowLeft />
					Coupons
				</Link>
				<PageHeader
					title="Coupon programs"
					count={!isLoading && !error ? programs.length : undefined}
					description="Recipes Braze calls at send time to issue one single-use coupon per recipient"
					actions={
						<Button asChild>
							<Link to="/coupons/programs/new">
								<Plus />
								Create program
							</Link>
						</Button>
					}
				/>
			</div>

			{error ? (
				<p className="text-bad">{error.message}</p>
			) : !isLoading && programs.length === 0 ? (
				<p className="text-muted-foreground">
					No programs yet. Create a program, then paste its Braze snippet into a
					canvas.
				</p>
			) : (
				<div className="min-h-0 flex-1">
					<CouponProgramsGrid programs={programs} isLoading={isLoading} />
				</div>
			)}
		</div>
	)
}
